import { useMemo } from "react";

import { formatBytes } from "../utils";

function useFormatFiles(files, coverages, additionalDocs) {
  function removeDuplicates(arr) {
    const uniqueItems = arr.reduce((acc, current) => {
      const currentFileName =
        current.name || current.fileName || current.filename;
      const x = acc.find((item) => item.name === currentFileName);
      if (!x) {
        acc.push({ ...current, name: current.name || current.filename });
      }
      return acc;
    }, []);
    return uniqueItems;
  }
  return useMemo(() => {
    const dedupedFiles = files?.length ? removeDuplicates(files) : [];
    const documents = coverages
      ?.flatMap(({ documents, product, name }) =>
        documents?.map((document) => ({
          ...document,
          product: product ? product.name : name,
        })),
      )
      .filter((doc) => doc);
    return dedupedFiles?.reduce((acc, f, id) => {
      const docFileName = f.name || f.filename || f.fileName;
      const fileDocuments = documents?.filter(
        ({ fileName }) =>
          fileName === docFileName ||
          fileName === docFileName?.replace(/\s/g, "+"),
      );

      const additionalDoc = additionalDocs?.some(
        (docName) =>
          docName === docFileName ||
          docName === docFileName?.replace(/\s/g, "+"),
      );

      if (fileDocuments?.length === 0 && !additionalDoc) {
        return acc;
      }

      const productsByType = fileDocuments?.reduce(
        (prodByTypeAcc, { product, type }) => {
          if (!prodByTypeAcc[type]) {
            prodByTypeAcc[type] = [];
          }
          prodByTypeAcc[type].push(product);
          return prodByTypeAcc;
        },
        {},
      );

      return [
        ...acc,
        {
          id,
          productsByType,
          size: formatBytes(f.size),
          original: f,
          additionalDoc,
        },
      ];
    }, []);
  }, [coverages, additionalDocs, files]);
}

export default useFormatFiles;
